import { Link } from 'react-router-dom';
import type { Category } from '@/mocks/categories';

interface CategoryTabsProps {
  categories: Category[];
  activeSlug?: string;
}

export default function CategoryTabs({ categories, activeSlug }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      <Link
        to="/"
        className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
          !activeSlug
            ? 'bg-primary-500 text-background-50'
            : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600'
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600'
          }`}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
}